<template>
  <div>
    <div class="heading-travel-policy">
      <span :class="hotelPreferredVendorObj.isActive ? 'tag is-success' : 'tag'"
        >Standard</span
      >

      <div class="right-content">
        <div class="lefttext">
          <p class="paragrapgh">Hotel is not a preferred vendor</p>
          <p>Trigger when the hotel is not a preferred vendor</p>
        </div>
        <div class="allbtns">
          <b-switch
            :rounded="true"
            :value="hotelPreferredVendorObj.isActive"
            v-model="hotelPreferredVendorObj.isActive"
            @input="hotelPreferredVendor"
          >
          </b-switch>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    value: {
      type: [Object],
    },
  },
  data() {
    return {
      hotelPreferredVendorObj: this.value
        ? this.value
        : {
            name: "hotelPreferredVendor",
            isActive: false,
            type: "hotel",
            message: "",
          },
    };
  },
  methods: {
    hotelPreferredVendor() {
      this.$emit("hotelPreferredVendor", this.hotelPreferredVendorObj);
    },
  },
  mounted() {
    this.hotelPreferredVendorObj.type = "hotel";
    this.hotelPreferredVendorObj.message = this.buildMessage;
    this.$emit("hotelPreferredVendor", this.hotelPreferredVendorObj);
  },
  computed: {
    buildMessage() {
      var string = "Trigger when the hotel is not a preferred vendor";

      return string;
    },
  },
  watch: {
    value: {
      handler(newVal, prevVal) {
        this.hotelPreferredVendorObj = this.value;
        this.hotelPreferredVendorObj.type = "hotel";
    this.hotelPreferredVendorObj.message = this.buildMessage;
        this.$emit("hotelPreferredVendor", this.hotelPreferredVendorObj);

      },
      deep: true,
    },
  },
};
</script>
